export const FETCH_PRICE_LOG_UPDATES = 'FETCH_PRICE_LOG_UPDATES';
export const PRICE_LOG_SET_PAGE_SIZE = 'PRICE_LOG_SET_PAGE_SIZE';
export const PRICE_LOG_SET_PAGE_NO = 'PRICE_LOG_SET_PAGE_NO';
export const CLEAR_PRICE_LOG = 'CLEAR_PRICE_LOG';
